import React from 'react';
import { TimkenUnit } from '../../components/bearing-search/types/types';
import { handleActionError } from '../utils/engineering-tools';

export type BearingTolerancesState = {
	unit: TimkenUnit;
	bearingClass: string;
};

export const initialTolerancesState: BearingTolerancesState = {
	unit: 'M',
	bearingClass: '',
};

export type BearingTolerancesAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'change_bearing_class'; payload: string }
	| { type: 'reset'; payload?: BearingTolerancesState };

const tolerancesReducer: React.Reducer<
	BearingTolerancesState,
	BearingTolerancesAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				unit: action.payload,
			};
		}
		case 'change_bearing_class': {
			return {
				...state,
				bearingClass: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialTolerancesState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default tolerancesReducer;
